import { Controller } from "@hotwired/stimulus"

// Two stacked iframes; toggling chips flips their hidden attribute so the
// iframes don't re-load on every click (avoids the tile-fade flash).
export default class extends Controller {
  static targets = ["chip", "iframe"]

  select(e) {
    const key = e.currentTarget.dataset.mapKey
    this.chipTargets.forEach(c => {
      const active = c.dataset.mapKey === key
      c.classList.toggle("active", active)
      c.setAttribute("aria-pressed", active ? "true" : "false")
    })
    this.iframeTargets.forEach(f => { f.hidden = f.dataset.mapKey !== key })
  }
}
